import { usersAPI } from "@/api";

export const uploadImageToServer = async ({
    file, fileName = 'Изображение', profileId
}) => {
    const dataForServer = new FormData()
        dataForServer.append('UserFilesForm[name]', fileName)
        dataForServer.append('UserFilesForm[user_id]', profileId)
        dataForServer.append('file', file)
    try {
        const response = await usersAPI.uploadPlatformMedia(dataForServer);
        return response?.data?.data?.path;
    } catch (error) {
        throw error;
    }
};